module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("15kLk"))).then(() => parcelRequire('hEqeo'));